import { ChevronRight, type LucideIcon } from 'lucide-react';

export interface AddToYarutaOptionProps {
  icon: LucideIcon;
  label: string;
  hint: string;
  onClick(): void;
  /** Divider on the top edge; the first row in a list hides it. */
  divider?: boolean;
}

/**
 * One way to add, inside the Add to Yaruta sheet (Figma
 * `Add to Yaruta / option`, 11693:8422): icon chip, title over hint,
 * chevron. 64px tall.
 */
export function AddToYarutaOption({
  icon: Icon,
  label,
  hint,
  onClick,
  divider = false,
}: AddToYarutaOptionProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        'flex h-16 w-full cursor-pointer items-center gap-3 py-3 text-left focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
        divider ? 'border-t border-border' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span className="flex size-10 shrink-0 items-center justify-center rounded-full border border-border bg-card">
        <Icon
          size={24}
          strokeWidth={1.5}
          className="text-icon-primary"
          aria-hidden="true"
        />
      </span>
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="text-base font-medium leading-6 text-text-heading">
          {label}
        </span>
        <span className="text-sm leading-5 text-text-caption">{hint}</span>
      </span>
      <ChevronRight
        size={20}
        strokeWidth={1.5}
        className="shrink-0 text-icon-default"
        aria-hidden="true"
      />
    </button>
  );
}
